import { type FC } from 'react';
import { styled } from 'styled-components';

import CheckMarkSvg from 'src/assets/checkmark-green.svg?react';

type PayByBankSelectCartPillProps = {
  hasDutchiePay?: boolean;
};

/**
 * Status pill on cart list rows (curbside / delivery) when a cart has already been paid via Pay By Bank.
 *
 * Deliberately leads with "Pre-Paid" rather than just the Pay By Bank name - a driver glancing at the
 * list should read this as "this order is settled", not as an instruction to collect payment via Pay
 * By Bank. The name after the separator identifies which payment method already ran.
 */
export const PayByBankSelectCartPill: FC<PayByBankSelectCartPillProps> = ({ hasDutchiePay }) => {
  if (!hasDutchiePay) {
    return null;
  }

  return (
    <Pill data-testid='pay-by-bank-cart-pill'>
      <CheckMarkIcon />
      Pre-Paid | Pay By Bank
    </Pill>
  );
};

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  flex-shrink: 0;
  padding: 0.25rem 0.6rem;
  border-radius: 0.875rem;
  color: white;
  background-color: var(--color-green-60);
`;

const CheckMarkIcon = styled(CheckMarkSvg)`
  width: 10px;
  height: 10px;
  flex-shrink: 0;

  path {
    fill: white;
  }
`;
